var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, } from 'react';
import clsx from 'clsx';
import { useDocument } from '../hooks/useDocument.js';
import { setPropertyValue } from '../utils/css-utils.js';
export const BottomBar = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    const { document } = useDocument();
    const Component = 'nav';
    useEffect(() => {
        setPropertyValue(document, '--c-bottom-bar-height', `48px`);
    }, []);
    return (React.createElement(Component, Object.assign({ className: clsx('flex justify-between items-stretch', 'h-[var(--c-bottom-bar-height)]', 'bg-topbar text-content-on-topbar', className), "aria-label": "Bottom Navigation" }, rest), children));
};
const BottomBarLink = props => {
    const { as, icon, active = false, className, children } = props, rest = __rest(props, ["as", "icon", "active", "className", "children"]);
    const Component = as || 'a';
    const itemClsx = [
        'text-sm truncate',
        active
            ? 'bg-topbar text-content-on-topbar'
            : 'bg-topbar hover:bg-topbar text-content-on-topbar hover:text-content-on-topbar',
    ];
    const iconClsx = [
        active
            ? 'text-content-on-topbar'
            : 'text-content-on-topbar group-hover:text-content-on-topbar',
    ];
    const paddingClsx = ['py-3 px-2'];
    return (React.createElement(Component, Object.assign({ className: clsx('w-full flex flex-col justify-start items-center transition duration-300', itemClsx, paddingClsx, className) }, rest),
        icon && (React.createElement("div", { className: clsx('flex-shrink-0 h-6 w-6', iconClsx) }, icon)),
        children));
};
BottomBar.Link = BottomBarLink;
//# sourceMappingURL=BottomBar.js.map